export default __webpack_public_path__ + "static/media/plain-sticker-by.c4b1429c.png";